export default __webpack_public_path__ + "static/sausage-66a96a6a5239c7b0f798d041bae449f9.jpg";